module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/_next/static/images/savethedate-11ff5d59b58921ff5c4554303275b59e.jpeg";